module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyNjI5NTc7fS5jbHMtMntmaWxsOm5vbmU7c3Ryb2tlOiMxZDFkMWI7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5kb3dubG9hZDwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI3IiB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMiIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMSIgeT0iMTQiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxIi8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxMS4wNCA5LjUgNy41IDEzLjA0IDMuOTYgOS41Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.svg
// module id = SZCR
// module chunks = 1